module.exports = __webpack_public_path__ + "c_static/img/Floating-button_btn_welfare_default@2x.28a151e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/Floating-button_btn_welfare_default@2x.png
// module id = R7H8
// module chunks = 33